import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 28 28',
    fill: 'currentColor',
    defaultAriaLabel: 'Chevron Down Icon',
};

export const ChevronDownIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.006 21.006a1 1 0 0 1-.707-.293l-8.006-8.006a1 1 0 1 1 1.414-1.414l7.299 7.299 7.299-7.3a1 1 0 0 1 1.414 1.415l-8.006 8.006a1 1 0 0 1-.707.293"
            />
        </SvgIcon>
    );
};
